<template>
  <v-container grid-list-lg>
    <v-layout>
      <div class="display-1 mb-5">
        <strong>Related Modules</strong>
      </div>
    </v-layout>

    <v-layout>
      <v-flex md4 v-for="(module, i) in relatedModules" :key="i">
        <v-card
          hover
          @click.native="handleClick(module.id)"
        >
          <v-card-media
            :src="module.media"
            height="200"
          >
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <div class="title mb-3">{{ module.title }}</div>
              <div class="mb-3">{{ module.subtitle }}</div>
              <strong>
                <span>CPD Points</span>
                <v-avatar color="primary" size="30">
                  <span class="white--text">{{ module.points }}</span>
                </v-avatar>
              </strong>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    relatedModules () {
      return this.serverData.modules
    }
  },
  created () {
    // this.fetchData()
  },
  data () {
    return {
      modules: []
    }
  },
  methods: {
    handleClick (moduleId) {
      console.log(moduleId)
      this.$router.push('/module/' + moduleId)
    },
    fetchData () {
      if (navigator.onLine) {
        console.log('User is online - Fetching tag information from server')
        localStorage.setItem('modules', JSON.stringify(this.modules))
      } else {
        console.log('User is offline - Fetching tag information from localstorage')
        this.$set(this, 'modules', JSON.parse(localStorage.getItem('modules')))
      }
      // console.log('items: ' + JSON.stringify(this.items))
    }
  },
  props: {
    serverData: {
      default () {
        return []
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/module/relatedModules.vue